import { projectApiUrl } from "API/urls/project.api";
import { axiosInstance } from "configs/axios";

export const updateProjectApi = async (payload) => {
  try {
    const response = await axiosInstance.post(projectApiUrl.updateProject, {
      ...payload,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
